import { DefaultDeviceController } from 'amazon-chime-sdk-js';

import { FilteredChimeLogger } from './filteredChimeLogger';

/**
 * Shared Chime device controller for voice meetings.
 *
 * DefaultMeetingSession only assigns `deviceController.eventController` when it
 * is unset. After a session is destroyed, that EventController's configuration
 * is cleared, but the shared DeviceController still holds the stale reference.
 * Later `startAudioInput` / `stopAudioInput` calls then publish events against
 * the destroyed controller and throw:
 * `Cannot read properties of undefined (reading 'credentials')`.
 *
 * Call `detachChimeEventController()` when tearing down a meeting session so
 * the next session can rebind a live EventController.
 */
let chimeSessionTearingDown = false;

export const setChimeSessionTearingDown = (value: boolean): void => {
  chimeSessionTearingDown = value;
};

export const isChimeSessionTearingDown = (): boolean => chimeSessionTearingDown;

export const chimeLogger = new FilteredChimeLogger({
  isTearingDown: isChimeSessionTearingDown,
});

export const chimeDeviceController = new DefaultDeviceController(chimeLogger, {
  enableWebAudio: true,
});

export const detachChimeEventController = (): void => {
  chimeDeviceController.eventController = undefined;
};
